import { createSelector } from 'reselect'
import STAGES from '../../constants/STAGES'

const getProgression = state => state.progression
const getStages = () => STAGES

const getStagesFromProgression = createSelector(
    getProgression,
    getStages,
    (progression, stages) => {
        const { stages: progStages } = progression
        return Object.values(stages).map((stage) => {
            const [chapterString, sectionString] = stage.ID.split('-')
            const chapter = parseInt(chapterString, 10)
            const section = parseInt(sectionString, 10)

            progStages[chapter] = progStages[chapter] || {}

            const status = progStages[chapter][section] || false

            return { ...stage, status }
        })
    }
)

export default getStagesFromProgression

